module.exports = __webpack_public_path__ + "static/media/08.0b6f88f2.png";